import { render, staticRenderFns } from "./resourcesList.vue?vue&type=template&id=2d0b3437&scoped=true&"
import script from "./resourcesList.vue?vue&type=script&lang=js&"
export * from "./resourcesList.vue?vue&type=script&lang=js&"
import style0 from "./resourcesList.vue?vue&type=style&index=0&id=2d0b3437&prod&scoped=true&lang=css&"
import style1 from "./resourcesList.vue?vue&type=style&index=1&id=2d0b3437&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b3437",
  null
  
)

export default component.exports